import { useRoutes } from "react-router-dom"

// project import
import LoginRoutes from "./LoginRoutes"
import MainRoutes from "./MainRoutes"
import AdminRoutes from "./AdminRoutes"
import LoadingRoutes from "./LoadingRoutes"
// ==============================|| ROUTING RENDER ||============================== //
import { useSelector } from "react-redux"
export default function ThemeRoutes() {
  const { isLogin, user, errorFetching } = useSelector((state) => state.user)
  const routes = []
  const accessToken = sessionStorage.getItem("accessToken")
  // if(errorFetching){
  //   return useRoutes([])
  // }
  if (!isLogin && accessToken == "null") {
    return useRoutes([LoginRoutes])
  } else if (!isLogin && !(accessToken == "null")) {
    return useRoutes([LoadingRoutes])
  } else {
    if (user?.userType == 3) {
      routes.push(AdminRoutes(isLogin))
    } else {
      routes.push(MainRoutes(isLogin))
    }
  }
  return useRoutes(routes)
}
